export const ITRVL = ['ITR006'];
export const JACADA = ['JAC007', 'JAC028', 'JAC031']; // JAC031 is the real deal.
export const YELLOW_ZEBRA = ['YEL002', 'YEL003'];

export const WILDERNESS = ['WIL290', 'WIL245', 'YEL003', 'WIL010'];
export const YELLOW_ZEBRA2 = ['YEL002'];
